import { afterNextRender, Component, DestroyRef, inject, OnInit, PLATFORM_ID, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { RouterOutlet } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import * as CookieConsent from "vanilla-cookieconsent";
import { CookieValue } from "vanilla-cookieconsent";
import { FooterComponent } from "./components/footer/footer.component";
import { LoadingComponent } from "./components/loading/loading.component";
import { NavigationComponent } from "./components/navigation/navigation.component";
import { getCookieConsentConfig } from "./config/cookie-consent.config";
import { GoogleTagManagerService } from "./services/google-tag-manager.service";

@Component({
    selector: "packbo-root",
    imports: [RouterOutlet, NavigationComponent, FooterComponent, LoadingComponent],
    templateUrl: "./app.template.html"
})
export class App implements OnInit {
    protected showLoading = signal(true);
    private readonly platformId = inject(PLATFORM_ID);
    private readonly translocoService = inject(TranslocoService);
    private readonly destroyRef = inject(DestroyRef);
    private readonly gtmService = inject(GoogleTagManagerService);

    constructor() {
        afterNextRender(() => {
            this.initializeCookieConsent();
            this.initializeGTMScripts();
        });
    }

    public ngOnInit(): void {
        setTimeout(() => {
            this.showLoading.set(false);
        }, 500);

        this.translocoService.langChanges$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((newLang) => {
            CookieConsent.setLanguage(newLang);
        });
    }

    private initializeCookieConsent(): void {
        const onConsentCb = ({ cookie: _cookie }: { cookie: CookieValue }): void => {
            const gtmConsent = CookieConsent.acceptedCategory("googleTagManager") ?? false;
            if (gtmConsent) {
                this.gtmService.injectGTM();
            } else {
                this.gtmService.removeGTM();
            }
        };

        const onChangeCb = ({ cookie: _cookie }: { cookie: CookieValue }): void => {
            const gtmConsent = CookieConsent.acceptedCategory("googleTagManager") ?? false;
            if (gtmConsent) {
                this.gtmService.injectGTM();
            } else {
                this.gtmService.removeGTM();
            }
        };

        const config = getCookieConsentConfig(this.translocoService.getActiveLang(), onConsentCb, onChangeCb);
        CookieConsent.run(config);
    }

    private initializeGTMScripts(): void {
        if (typeof document === "undefined" || typeof window === "undefined") {
            return;
        }

        const hasValidConsent = CookieConsent.validConsent() ?? false;
        const gtmConsent = CookieConsent.acceptedCategory("googleTagManager") ?? false;

        console.log("hasValidConsent", hasValidConsent);
        console.log("gtmConsent", gtmConsent);

        if (!hasValidConsent || (hasValidConsent && gtmConsent)) {
            this.gtmService.injectGTM();
        } else {
            this.gtmService.removeGTM();
        }
    }
}
